// Module
var code = " <p align=\"center\" style=\"color:#000;font-weight:700;font-size:16px\"> Les inscriptions pour cet examen sont clôturées. <br/>Merci de contacter votre centre d'examen si besoin. </p>";
// Exports
export default code;